export const authKeys = {
  all: ["auth"] as const,
  me: () => [...authKeys.all, "me"] as const,
};

export const userKeys = {
  all: ["users"] as const,
  lists: () => [...userKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...userKeys.lists(), filters] as const,
  details: () => [...userKeys.all, "detail"] as const,
  detail: (id: number) => [...userKeys.details(), id] as const,
};

export const surveyKeys = {
  all: ["surveys"] as const,
  lists: () => [...surveyKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...surveyKeys.lists(), filters] as const,
  details: () => [...surveyKeys.all, "detail"] as const,
  detail: (id: number) => [...surveyKeys.details(), id] as const,
  syncUsers: (id: number) => [...surveyKeys.all, id, "sync-users"] as const,
};

export const surveyPermissionKeys = {
  all: (surveyId: number) => ["survey-permissions", surveyId] as const,
  list: (surveyId: number) => [...surveyPermissionKeys.all(surveyId), "list"] as const,
};

export const surveyLinkKeys = {
  all: (surveyId: number) => ["survey-links", surveyId] as const,
  list: (surveyId: number) => [...surveyLinkKeys.all(surveyId), "list"] as const,
};

export const pageKeys = {
  all: (surveyId: number) => ["pages", surveyId] as const,
  list: (surveyId: number) => [...pageKeys.all(surveyId), "list"] as const,
};

export const questionKeys = {
  all: (pageId: number) => ["questions", pageId] as const,
  list: (pageId: number) => [...questionKeys.all(pageId), "list"] as const,
};

export const analyticsKeys = {
  all: (surveyId: number) => ["analytics", surveyId] as const,
  summary: (surveyId: number, filters: Record<string, unknown>) =>
    [...analyticsKeys.all(surveyId), "summary", filters] as const,
  responses: (surveyId: number, query: Record<string, unknown>) =>
    [...analyticsKeys.all(surveyId), "responses", query] as const,
  responseAnswers: (surveyId: number, responseId: number) =>
    [...analyticsKeys.all(surveyId), "response-answers", responseId] as const,
  pivot: (surveyId: number, query: Record<string, unknown>) =>
    [...analyticsKeys.all(surveyId), "pivot", query] as const,
  spam: (surveyId: number) => [...analyticsKeys.all(surveyId), "spam"] as const,
  layout: (surveyId: number) => [...analyticsKeys.all(surveyId), "layout"] as const,
};

export const reportKeys = {
  all: (surveyId: number) => ["reports", surveyId] as const,
  lists: (surveyId: number) => [...reportKeys.all(surveyId), "list"] as const,
  details: (surveyId: number) => [...reportKeys.all(surveyId), "detail"] as const,
  detail: (surveyId: number, reportId: number, filters?: Record<string, unknown>) =>
    [...reportKeys.details(surveyId), reportId, filters ?? {}] as const,
  evaluate: (surveyId: number, reportId: number, filters?: Record<string, unknown>) =>
    [...reportKeys.all(surveyId), "evaluate", reportId, filters ?? {}] as const,
};

export const contactKeys = {
  all: ["contacts"] as const,
  lists: () => [...contactKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...contactKeys.lists(), filters] as const,
};

export const landingKeys = {
  surveys: ["landing", "surveys"] as const,
};

export const accessKeys = {
  selfCheck: ["access", "self-check"] as const,
};

export const exportJobKeys = {
  status: (jobId: string, queue: string) => ["export-job", jobId, queue] as const,
  dlq: ["export-dlq"] as const,
};

export const accessRuleKeys = {
  all: ["access-rules"] as const,
  list: () => [...accessRuleKeys.all, "list"] as const,
};
